import { render, staticRenderFns } from "./Consignments.vue?vue&type=template&id=7a75e2df&scoped=true&"
import script from "./Consignments.vue?vue&type=script&lang=js&"
export * from "./Consignments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a75e2df",
  null
  
)

export default component.exports